import FollowingListModal from './FollowingListModal';

export default FollowingListModal;
